import React from 'react';

import colors from '@opendoor/bricks/theme/eero/foundations/colors';

export const CheckIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 11C21 16.5235 16.5217 21 11 21C5.47565 21 1 16.5235 1 11C1 5.47652 5.47565 1 11 1C16.5217 1 21 5.47652 21 11Z"
      fill={colors.green50}
      stroke={colors.green50}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3478 7.95653L8.82601 14.0435L6.6521 11.8696"
      stroke={colors.neutrals0}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
